import { AlertModal, Text } from '@modusign/design-system';
import { ReactNode } from 'react';

import { ContentBox } from '@app/features/workspaceManagement';

interface ExcelUploadErrorModalProps {
  guide?: ReactNode;
  errorMessage: ReactNode;
  isOpen: boolean;
  onClose: () => void;
}

function ExcelUploadErrorModal({
  guide = (
    <>
      엑셀 파일 업로드를 할 수 없습니다.
      <br />
      확인 후, 다시 시도해 주세요.
    </>
  ),
  errorMessage,
  isOpen,
  onClose,
}: ExcelUploadErrorModalProps) {
  return (
    <AlertModal
      isOpen={isOpen}
      maxWidth="xs"
      title="업로드 안내"
      variant="warning"
      onClose={onClose}
    >
      <Text as="p" pb={4}>
        {guide}
      </Text>
      {errorMessage && (
        <ContentBox px={6} py={6}>
          {errorMessage}
        </ContentBox>
      )}
    </AlertModal>
  );
}

export default ExcelUploadErrorModal;
